<template>
  <Header />
  <Navigation />
  <div class="container">
    <router-view />
  </div>
  <Footer />
  <Loader />
</template>

<script>
import Header from "@/views/layouts/Header.vue";
import Footer from "@/views/layouts/Footer.vue";
import Loader from "@/views/Loader.vue";
import Navigation from "@/views/layouts/Navigation.vue";

export default {
  components: {
    Header,
    Footer,
    Loader,
    Navigation,
  },
  mounted() {
    const routerDiv = document.querySelector("div.container");
    routerDiv.addEventListener("click", () => {
      // 画面をクリックしたらナビゲーションを閉じる
      document.querySelector("#menu-btn-check").checked = false;
    });
  }
};
</script>

<!-- コンポーネント全体にスタイルを反映 -->
<style>
@import "./assets/css/styles.css";
</style>

<style scoped>
</style>
